import {Translate} from 'react-redux-i18n';
import PropTypes from 'prop-types';
import {CountryFlag as CoreCountryFlag} from 'front-onceforall-core';

function CountryFlagView(props) {
  const label = <Translate value={`country.${props.country}`}/>;

  return (
    <div
      className="flex-container"
      style={{width: '100%'}}
    >
      <CoreCountryFlag
        country={props.country}
        size={props.size}
      />
      {props.showLabel &&
        <span
          className="ellipsis"
          style={{width: 'calc(100% - 22px)'}}
        >
          {label}
        </span>
      }
    </div>
  );
}

CountryFlagView.defaultProps = {
  showLabel: true,
  size: 16
};

CountryFlagView.propTypes = {
  country: PropTypes.string.isRequired,
  showLabel: PropTypes.bool,
  size: PropTypes.number
};

export default CountryFlagView;
